
export type Tags = {
  readonly tags: {
    readonly tag: ReadonlyArray<{
      readonly label: string;
    }>;
  };
};

export type TaggableCatalogTypes = {
  contentType: 'database' | 'table';
};

export const TaggableCatalogTypesRestApiVersion = '3.9';
